<template>
  <div class="pc-course-series">
    <div class="pc-course-series-header">
      <h2>竞赛奖项</h2>
      <div class="pc-button-group">
        <el-button
          @click="manageSeries"
          v-show="isEditting == false"
          class="pc-btn"
        >
          管理
        </el-button>
        <el-button @click="save" v-show="isEditting" class="pc-btn">
          完成
        </el-button>
      </div>
    </div>
    <ul class="series-list">
      <li
        v-for="(item, index) in awardList"
        :key="index"
        class="series-item"
        @click="goSeriesPage(item.id, item.chinese_name)"
      >
        <div class="series-item-content">
          <div class="nameBox">
            <p class="name">{{ item.chinese_award_name }}</p>
            <p class="name">{{ item.english_award_name }}</p>
          </div>
          <!-- <div class="lineBox">
            <span></span>
          </div>
          <div class="numberBox">
            <p class="number">
              <span>
                {{ item.award_count }}
              </span>
              <span> 个 </span>
            </p>
          </div> -->
        </div>

        <!-- <div v-if="item.status != 1" class="lost-icon">无效</div> -->
        <div class="choice" v-show="isEditting">
          <div
            v-show="isEditting"
            @click="modifyTheme(item)"
            class="choice-delete"
          >
            <i class="el-icon-edit"></i>
          </div>
          <!-- 点击编辑显示的删除样式 -->
          <div
            v-show="isEditting"
            @click="deleteSeries(item.id)"
            class="choice-delete"
          >
            <i class="el-icon-circle-close"></i>
          </div>
        </div>
      </li>
      <li>
        <el-button
          v-show="isEditting"
          class="pc-btn addbtn"
          @click="addAward()"
        >
          添加奖项
        </el-button>
      </li>
    </ul>
    <ul class="pagination" v-if="total > 12">
      <li
        v-for="(item, index) in Math.ceil(total / 12)"
        :key="index"
        :class="page == index + 1 ? 'choicePage' : ''"
        @click="changePage(index)"
      ></li>
    </ul>
    <el-dialog class="committeeDialog" :visible.sync="isUpdateShow" width="40%">
      <el-form label-width="150px">
        <el-form-item label="中文名称">
          <el-input
            v-model="awardContent.chinese_award_name"
            placeholder="请输入奖项中文名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="英文名称">
          <el-input
            v-model="awardContent.english_award_name"
            placeholder="请输入奖项英文名称"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="奖项数量">
          <el-input
            v-model="awardContent.award_count"
            placeholder="请输入奖项数量"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="是否纳入人气奖投票">
          <el-switch
            v-model="awardContent.vote_flag"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            :active-value="1"
            :inactive-value="0"
            style="align-self: center"
          ></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-footer-button-one"
          @click="isUpdateShow = false"
          >取 消</el-button
        >
        <el-button
          class="dialog-footer-button-second"
          type="primary"
          @click="submitBanner()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <DeleteDialog
      :dialogVisible="deleteDialogVisible"
      @isCancel="closeDelete"
      @isDelete="deleteConfirm"
    />
  </div>
</template>

<script>
import DeleteDialog from "../../../componentSet/DeleteDialog";
import {
  competitionAward_Api,
  createCompetitionAward_Api,
  deleteCompetitionAward_Api,
  updateCompetitionAward_Api,
} from "../../../../apis/competition.api";
export default {
  props: ["competitionDetail"],
  data() {
    return {
      isEditting: false,
      isUpdateShow: false,
      deleteDialogVisible: false,
      awardList: [],
      awardContent: {
        award_id: null,
        competition_id: null,
        chinese_award_name: "测试奖项01",
        english_award_name: "TestAward01",
        award_count: null,
        vote_flag: null,
      },
      awardDetail: { award_id: null },
      page: 1,
      total: 0,
      deleteAwardId: 0,
    };
  },
  components: {
    DeleteDialog,
  },
  mounted() {
    this.getCompetitionAwardList();
  },
  methods: {
    getCompetitionAwardList(hint) {
      competitionAward_Api(this.$route.query.id).then((res) => {
        this.awardList = res.data;
        hint ? this.$global.success(this, hint) : "";
      });
    },
    addAward() {
      this.isUpdateShow = true;
      for (let key in this.awardContent) {
        this.awardContent[key] = null;
      }
    },
    manageSeries() {
      this.isEditting = true;
    },
    save() {
      this.isEditting = false;
    },
    deleteSeries(id) {
      this.deleteAwardId = id;
      this.deleteDialogVisible = true;
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    goSeriesPage(id) {
      // if (this.isEditting == false) {
      //   this.$router.push({
      //     path: "/admin/seriesdetail",
      //     query: { id: id, method:'update' },
      //     name: "seriesdetail",
      //   })
      // }
    },
    deleteConfirm() {
      deleteCompetitionAward_Api({ award_id: this.deleteAwardId }).then(() => {
        this.getCompetitionAwardList();
        this.deleteDialogVisible = false;
      });
    },
    submitBanner() {
      this.awardContent.competition_id = this.competitionDetail.id;
      this.awardContent.award_count = 50;
      if (!this.awardContent.award_id) {
        createCompetitionAward_Api(this.awardContent).then((res) => {
          if (res.code == 404) {
            this.$global.error(
              this,
              "奖项只能当竞赛处于'未开始'、'报名中'、'投稿中'  三个阶段时才能修改"
            );
            return;
          }
          this.getCompetitionAwardList();
          this.isUpdateShow = false;
        });
      } else {
        updateCompetitionAward_Api(this.awardContent).then((res) => {
          if (res.code == 404) {
            this.$global.error(
              this,
              "奖项只能当竞赛处于'未开始'、'报名中'、'投稿中'  三个阶段时才能修改"
            );
            return;
          }
          this.getCompetitionAwardList();
          this.isUpdateShow = false;
        });
      }
    },
    modifyTheme(item) {
      this.isUpdateShow = true;
      console.log(item);
      this.awardContent.award_id = item.id;
      this.awardContent.chinese_award_name = item.chinese_award_name;
      this.awardContent.english_award_name = item.english_award_name;
      this.awardContent.award_count = item.award_count;
      this.awardContent.vote_flag = item.vote_flag;
    },
    changePage(index) {
      this.page = index + 1;
      this.getCompetitionAwardList(this.page, "获取奖项成功");
    },
  },
};
</script>

<style scoped lang='scss'>
.pc-course-series {
  @include box-model;
  .pc-course-series-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #c0c0c0;
    > h2 {
      font-size: 20px;
      padding-bottom: 15px;
      color: $mainTitle;
    }
    .pc-button-group {
      margin-top: -10px;
      .pc-btn {
        @include manage-button;
      }
    }
  }

  .series-list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    margin-top: 30px;
    height: 180px;
    overflow: hidden;
    .pc-btn {
      @include manage-button;
    }
    .addbtn {
      width: 170px;
      height: 58px;
      color: $blueBtna;
      background: white;
      border: 1px dashed rgb(105, 129, 205);
      border-radius: 4px;
    }
    .series-item {
      width: 16%;
      margin-right: 0.6%;
      height: 60px;
      border-radius: 4px;
      border: 1px solid rgb(105, 129, 205);
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      cursor: pointer;
      position: relative;
      .series-item-content {
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 100%;
        width: 100%;
        margin: 0;

        .nameBox {
          width: 90px;
          margin: 10px 10px 0 0;
          .name {
            @include ellipsis;
            width: 100%;
            height: 14px;
            font-size: 14px;
            font-weight: 400;
            margin-bottom: 10px;
            color: rgb(105, 129, 205);
            line-height: 14px;
          }
        }
        .lineBox {
          background: #dad6d6;
          height: 60%;
          width: 1.5px;
        }
        .numberBox {
          width: 30%;
          height: 100%;
          .number {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            font-size: 15px;

            align-items: center;
            span:nth-child(1) {
              display: inline-block;
              font-size: 16px;
              margin-right: 2px;
              height: 14px;
              line-height: 14px;
              color: $lightenYellow;
            }
            span:nth-child(2) {
              font-size: 11px;
              margin-top: 5px;
              display: inline-block;
              height: 14px;
              line-height: 14px;
              color: #c0c0c0;
            }
          }
        }
      }
      .choice {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        border-radius: 0px 4px 4px 0;
        // background:rgba($color: #000000, $alpha: 0.4);
        .choice-delete:nth-child(1) {
          display: none;
        }
        //   /deep/ .el-icon-edit:hover {
        //     color: $lightenYellow;
        //   }
        // }
        .choice-delete:nth-child(2) {
          display: none;
        }
        //   /deep/ .el-icon-circle-close:hover {
        //     color: $lightenYellow;
        //   }
        // }
      }
      .choice:hover {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        border-radius: 0px 4px 4px 0;
        background: rgba($color: #000000, $alpha: 0.4);
        .choice-delete:nth-child(1) {
          display: block;
          width: 20%;
          height: 20%;
          display: flex;
          justify-content: center;
          border-radius: 0px 4px 4px 0;
          /deep/ .el-icon-edit {
            font-size: 20px;
            color: white;
          }
          /deep/ .el-icon-edit:hover {
            color: $lightenYellow;
          }
        }
        .choice-delete:nth-child(2) {
          display: block;
          width: 20%;
          height: 20%;
          display: flex;
          justify-content: center;
          border-radius: 0px 4px 4px 0;
          /deep/ .el-icon-circle-close {
            font-size: 20px;
            color: white;
          }
          /deep/ .el-icon-circle-close:hover {
            color: $lightenYellow;
          }
        }
      }
    }
    .active:hover {
      transform: translateY(-20px);
      transition: 0.6s;
    }
    .lost {
      opacity: 0.44;
      position: relative;
      overflow: hidden;
      .lost-icon {
        position: absolute;
        width: 60px;
        top: 6px;
        left: -16px;
        text-align: center;
        background: $blueBtna;
        font-size: 10px;
        font-weight: 400;
        color: $base-color;
        transform: rotate(-45deg);
      }
    }
  }

  // // 课程系列换页
  .pagination {
    display: flex;
    justify-content: center;
    li {
      cursor: pointer;
      width: 34px;
      height: 5px;
      background: $schoolTagBorder;
      margin-right: 10px;
    }
    .choicePage {
      background: $blueBtna;
    }
  }
  /deep/ .el-dialog__footer {
    .dialog-footer-button-one {
      @include manage-button;
      background: $test;
      color: $blueBtna;
    }
    .dialog-footer-button-second {
      @include manage-button;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/competition/components/CompetitionPrize.vue